import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoChevronForward } from 'react-icons/io5';
import { scenarioApi } from '@/api/scenarios';
import { Scenario } from '@/types/assistants';
import { Button } from '@/components/ui/Button';
import { PlusLogo, SettingsSteps } from '@/assets/Logos';
import {
    StepsTable,
    StyledSpan
} from '../styles/AssistantsPage.styles';
import { Breadcrumbs } from "@/components/ui/Breadcrumbs.ts";
import { Title } from "@/components/ui/Title.ts";
import { styled } from 'styled-components';
import {useAppDispatch, useAppSelector} from '@/hooks/redux';
import { SkeletonTable } from "../../components/ui/Loaders/SkeletonTable";
import {fetchAssistant} from "@/store/assistantSlice.ts";

const StepHeader = styled.div`
  display: grid;
  grid-template-columns: 276px 108px 1fr 140px;
  gap: 16px;
  padding: 12px 0;
  align-items: start;
  font-weight: 400;
  font-size: 14px;
  background: rgb(246, 243, 243);
  border-radius: 6px;
`;

const StepRow = styled.div`
  display: grid;
 grid-template-columns: 276px 108px 1fr 140px;
  gap: 16px;
  padding: 19px 0;
  align-items: start;
  font-weight: 400;
  font-size: 14px;
  border-bottom: 1px solid rgb(232, 232, 232);
  
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
`;

export const AssistantsScenariosPage = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { assistant } = useAppSelector(state => state.assistant);
    const [scenarios, setScenarios] = useState<Scenario[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (id) {
            setIsLoading(true);
            dispatch(fetchAssistant(Number(id)))
            scenarioApi.getAll().then(({ data }) => {
                const filteredScenarios = data.filter(
                    (scenario: Scenario) => scenario.AssistantID === parseInt(id)
                );
                setScenarios(filteredScenarios);
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }, [id]);

    return (
        <div>
            <Header>
                <Title>{assistant?.Name}</Title>
                <div style={{display: 'flex', gap: '10px'}}>
                    <Button variant="secondary" padding="10px 25px 10px 19px" onClick={() => navigate(`/dashboard/assistants/${id}`)}>
                        <StyledSpan>Настройки ассистента</StyledSpan>
                    </Button>
                <Button
                    variant="blue"
                    padding="10px 25px 10px 19px"
                    onClick={() => navigate(`/dashboard/assistants/${id}/scenarios/add`)}
                >
                    <PlusLogo/>
                    <StyledSpan>Добавить сценарий</StyledSpan>
                </Button>
                </div>
            </Header>
            <Breadcrumbs>
                <Link to="/dashboard/assistants">Мои ассистенты</Link>
                <IoChevronForward size={14} color="#000000" />
                <span>{assistant?.Name}</span>
            </Breadcrumbs>
            {isLoading ? <SkeletonTable rows={4} cols={3} /> : (
                <StepsTable>
                    <StepHeader>
                        <div style={{ marginLeft: '16px' }}>Наименование</div>
                        <div style={{ marginLeft: '16px' }}>Script ID</div>
                        <div style={{ marginLeft: '24px' }}>Описание</div>
                        <div style={{ marginLeft: '16px' }}>Дата создания</div>
                    </StepHeader>
                    {!scenarios ? (
                        <div style={{
                            padding: '20px 16px',
                            color: '#666',
                            fontSize: '14px',
                            textAlign: 'center'
                        }}>
                            Пока нет сценариев
                        </div>
                    ) : (
                        scenarios.map((scenario) => (
                            <StepRow key={scenario.ID}>
                                <div style={{
                                    marginLeft: '16px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: 'rgb(35, 88, 162)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <Link to={`/dashboard/assistants/${assistant?.ID}/scenarios/${scenario.ID}/steps`}>
                                        {scenario.Name}
                                    </Link>
                                    {scenario.IsDefault && <SettingsSteps/>}
                                </div>
                                <div style={{ marginLeft: '16px' }}>{scenario.ScriptID}</div>
                                <div style={{ marginLeft: '24px' }}>{scenario.Description}</div>
                                <div style={{ marginLeft: '16px' }}>
                                    {new Date(scenario.CreatedAt).toLocaleDateString()}
                                </div>
                            </StepRow>
                        ))
                    )}
                </StepsTable>
            )}
        </div>
    );
};
